import WindowFloat from '@/frontend/components/qecomps/WindowFloat'
import { useState } from "react"
import TextEndAbbreviation from '@/frontend/components/qecomps/TextEndAbbreviation'
import Cap from '@/frontend/components/qecomps/Cap'
import Bold from '@/frontend/components/qecomps/Bold'

import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import Img from '../qecomps/Img'
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {
  
    var [form, setForm] = useState({index:null, download:false})
    return <>
    <WindowFloat title={z.lang.watchvideos} onclose={()=>{props.onclose?.()}}>
    {props.item.videos.map((f,i)=><div style={{fontSize:12}}><c-x 
    style={{height:null, borderRadius:5, width:"100%", fontSize:12, cursor:"pointer",
    padding:"5px 5px", backgroundColor:form.index == i?"green":null}}
        onClick={()=>
        {
          if(i != form.index)
          {
            setForm({index:i, download:false})
          }
          else
          {
            setForm({index:null, download:false})
          }
        }}
        class={z.styles.curselitem}>
          <f-csb  style={{width:"100%"}}>
              <f-c>
                <sp-3/><Img src={global.cdn("/files/video4.svg")} style={{width:20, height:20}} />
                <sp-3/><span>{props.item.videos[i].name}</span>
              </f-c>
          </f-csb>
          </c-x>

          <br-xxx/>
          
          {form.index == i?<div style={{padding:"5px 5px", borderRadius:5, backgroundColor:"#eacfad"}}>
          
            {form.download?<>
            <f-csb><Bold>{Cap(z.lang.download)+":"}</Bold><a style={{fontSize:11}} onClick={()=>setForm({index:i, download:false})}>{z.lang.back}</a></f-csb></>
             :<Bold>{z.lang.watchby}</Bold>}

            <br-x/>
            <f-cse>
              
            {!form.download?<>
                <f-cc onClick={()=>{
                props.item.selectedvindex = i;
                props.item.selectedvplayer = "qeplayer"
                props.onclose?.()
                }}><Img src={global.cdn('/files/logocircular.webp')}
                  style={{display:"inline-block", verticalAlign:"middle",width:22, height:18, borderRadius:5}} /><sp-4/>
                  <a  >{z.lang.qeplayer}</a>
                </f-cc>

                <f-cc onClick={()=>{
                props.item.selectedvindex = i;
                props.item.selectedvplayer = "iframe"
                props.onclose?.()
                }}><Img src={global.cdn('/files/youtube1.svg')}
                  style={{display:"inline-block", verticalAlign:"middle",width:22, height:22}} /><sp-4/>
                  <a  >{z.lang.youtube}</a>
                </f-cc>

                <f-cc onClick={()=>
                {
                  setForm({index:i, download:true})
                }}><Img src={global.cdn('/files/download.svg')}
                  style={{display:"inline-block", verticalAlign:"middle",width:20, height:18}} /><sp-4/>
                  <a style={{marginBottom:-2}}>{z.lang.download}</a>
                </f-cc>
              </>:null}


              {form.download?<>
                <f-cc><Img src={global.cdn('/files/video4.svg')}
                  style={{display:"inline-block", verticalAlign:"middle",width:20, height:18}} /><sp-4/>
                  <a  href={props.item.videos[i].direct+"?"+ TextEndAbbreviation(props.item.videos[i].name,25)+".mp4"}
                  target="_blank">{z.lang.direct}</a>
                </f-cc>

                <f-cc><Img src={global.cdn('/files/vtt.svg')}
                  style={{display:"inline-block", verticalAlign:"middle",width:20, height:18}} /><sp-4/>
                  <a  href={props.item.videos[i].subtitle+"?"+ TextEndAbbreviation(props.item.videos[i].name,25)+".vtt"}
                   target="_blank">{z.lang.subtitle}</a>
                </f-cc>
              </>:null}

            </f-cse>
            <br-xx/>
          </div>:null}
          
        <br-xxx/></div>)}
      </WindowFloat>
    </>
}